import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class ActionCollectionsOrganizationsCountries extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'ActionCollectionsOrganizationsCountries'
  // Define default properties here
  static instanceDefaults () {
    return {
      actionCollectionsOrganizationsId: 1,
      countryId: 1,
    }
  }
}
const servicePath = 'action-collections-organizations-countries'
const servicePlugin = makeServicePlugin({
  Model: ActionCollectionsOrganizationsCountries,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
